<script setup lang="ts">
import Offcanvas from '@/modules/bootstrap/components/Offcanvas.vue';
import ToggleButton from '@/modules/bootstrap/components/ToggleButton.vue';
import { defineProps, ref, onMounted } from 'vue';
import Icon from "@/components/Icon.vue";
import { mdiMenu } from "@mdi/js";
import { metadata } from '@/lib/metadata';
// import * as list from '@/modules/editor/views';
interface Item {
    label: string,
    url: string,
    active?: boolean;
}

type Props = {
    list: Item[]
};
const { list } = defineProps<Props>();
// const offcanvasElt = ref<any>(null)
const scrollTo = (id) => {
    const section = document.getElementById(id);
    offcanvas.value.close()
    if (section) {
        section.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        })
    }
}

const offcanvas = ref<any>(null)
const canvasEl = (el: any, element: any) => {
    element(el)
    offcanvas.value = el;
}


onMounted(() => {
})
</script>
<template>
    <ToggleButton class="btn-side">

        <Icon :path="mdiMenu" />

        <template #content="{ element, closed }">
            <Offcanvas
                backdrop
                :ref="(el) => { canvasEl(el, element) }"
                placement="end"
                @closed="closed"
                :logo="`${metadata()?.url?.base?.absolute}/images/sitelogo.png`"
            >
                <ul class="menu-list">
                    <li
                        class="menu-item"
                        v-for="item in list"
                    >
                        <a
                            class="link"
                            :href="item.url"
                        >{{ item.label }}</a>
                    </li>
                </ul>
            </Offcanvas>
        </template>
    </ToggleButton>
</template>
